import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResponseApi } from '../../../dtos/ResponseApi';
import { PerfilResponse } from '../../../dtos/core/perfil/PerfilResponse';
import { CreatePerfilDto } from '../../../dtos/core/perfil/CreatePerfilDto';
import { SortPerfilHierarquiaDto } from '../../../dtos/core/perfil/SortPerfilHierarquiaDto';

@Injectable({
  providedIn: 'root'
})
export class PerfilService {
  private baseUrl = `${environment.apiUrl}/core/perfil`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<ResponseApi<PerfilResponse[]>> {
    return this.http.get<ResponseApi<PerfilResponse[]>>(this.baseUrl);
  }

  create(request: CreatePerfilDto): Observable<ResponseApi<PerfilResponse>> {
    return this.http.post<ResponseApi<PerfilResponse>>(this.baseUrl, request);
  }

  update(request: CreatePerfilDto): Observable<ResponseApi<PerfilResponse>> {
    return this.http.put<ResponseApi<PerfilResponse>>(this.baseUrl, request);
  }

  updateOrder(perfis: SortPerfilHierarquiaDto[]): Observable<ResponseApi<PerfilResponse[]>> {
    return this.http.put<ResponseApi<PerfilResponse[]>>(`${this.baseUrl}/sort`, { perfis: perfis });
  }

  delete(id: string): Observable<ResponseApi<void>> {
    return this.http.delete<ResponseApi<void>>(`${this.baseUrl}/${id}`);
  }
}
